var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { class: _vm.layoutNavbarClass },
    [
      _vm.isDesktop
        ? _c(
            "div",
            { staticClass: "container" },
            [
              _vm.config.has_geolocation_access
                ? _c("geolocation-navbar", {
                    attrs: { "show-text": !_vm.$can("awards") },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$router.push({ name: "Próximos a você" })
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$can("engagement")
                ? _c("engagement-navbar", {
                    attrs: {
                      "show-engagement-button": _vm.showEngagementButton
                    },
                    on: {
                      "engagement-button-click": _vm.handleEngagementButton
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !!(_vm.config || {}).has_request_partners
                ? _c("become-partner-navbar", {
                    nativeOn: {
                      click: function($event) {
                        return _vm.$router.push({ name: "Seja parceiro" })
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("profile-gtm-navbar", {
                ref: "menu",
                nativeOn: {
                  click: function($event) {
                    return _vm.handleUser(true)
                  }
                }
              }),
              _vm._v(" "),
              _c("notification-navbar", {
                attrs: { "has-new-notification": _vm.newNotification }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _vm.showMenu
        ? _c(
            "c-popover",
            {
              attrs: { position: ["top", "right"], target: _vm.$refs["menu"] },
              on: {
                blur: function($event) {
                  _vm.showMenu = false
                }
              }
            },
            [
              _c(
                "layout-menu",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        items: _vm.menuItems,
                        config: _vm.config,
                        loading: _vm.loading,
                        coin: _vm.coin,
                        "engagement-balance": _vm.engagement_balance
                      },
                      on: {
                        close: function($event) {
                          _vm.showMenu = false
                        }
                      }
                    },
                    "layout-menu",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "navbar" },
        [
          _vm.showBackButton
            ? _c("k-icon-button", {
                staticClass: "back-button",
                attrs: { type: "left1" },
                nativeOn: {
                  click: function($event) {
                    return _vm.$router.back()
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoading
            ? _c("c-spinner", {
                staticClass: "logo loading",
                attrs: { size: "sm" }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoading && (_vm.isDesktop || _vm.config.mobile_logo)
            ? _c("c-image-logo", {
                staticClass: "logo logo-gtm",
                attrs: {
                  "data-cy": "navbar-logo",
                  src: _vm.company && _vm.company.logo,
                  placeholder: _vm.placeholder,
                  alt: _vm.config.title
                },
                nativeOn: {
                  click: function($event) {
                    return _vm.handleRouteHome.apply(null, arguments)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("section", { staticClass: "actions" }, [
            _c(
              "div",
              { staticClass: "right-side" },
              [
                !_vm.isDesktop && _vm.config.has_geolocation_access
                  ? _c("geolocation-navbar", {
                      staticClass: "button",
                      nativeOn: {
                        click: function($event) {
                          return _vm.$router.push({ name: "Próximos a você" })
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("c-button", {
                  staticClass: "button search",
                  attrs: { size: "lg", icon: "search", "icon-size": "17" },
                  on: {
                    click: function($event) {
                      return _vm.search($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("notification-navbar", {
                  attrs: { "has-new-notification": _vm.newNotification },
                  nativeOn: {
                    click: function($event) {
                      return _vm.$emit("toggleNotifications")
                    }
                  }
                }),
                _vm._v(" "),
                _c("c-button", {
                  staticClass: "button profile",
                  attrs: { size: "lg", icon: "menu" },
                  on: { click: _vm.handleUser }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isDesktop && _vm.$can("engagement")
        ? _c("c-tabber", {
            staticClass: "toggler",
            attrs: { tabs: _vm.tabs, "active-tab": _vm.activeTab },
            on: {
              "change-tab": function(tab) {
                return _vm.handleSubmit(tab)
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25a1d93f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25a1d93f","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/LayoutNavbar.vue
// module id = 2104
// module chunks = 1610